// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"44a35a49","92":"642e0499","99":"2d034241","215":"ca38c6aa","337":"51c131d3","443":"9fee6f53","479":"f244353f","531":"7f164777","804":"b25592cd"}[chunkId] + ".chunk.js";
};